import {LicPackageKeys, LicPackageLevel} from "../constans/roles";
import {AnimalTypes} from "../constans/animalTypes";
import insertion from "../resources/images/events/insertion.svg";
import {EventCategory} from "../constans/eventTypes";
import formDataDB from "../database/formDataDB";
import {eventChooserFormNames} from "../constans/formNames";
import insemination from "../resources/images/events/insemination.svg";
import usg from "../resources/images/events/usg.svg";
import noPregnancy from "../resources/images/events/no-pregnancy.svg";
import parturition from "../resources/images/events/parturition.svg";
import separationPorkhouse from "../resources/images/events/separation-porkhouse.svg";
import separationMommy from "../resources/images/events/separation-mommy.svg";
import grafting from "../resources/images/events/grafting.svg";
import treatment from "../resources/images/events/treatment.svg";
import fallPiglets from "../resources/images/events/fall-piglets.svg";
import transfer from "../resources/images/events/transfer.svg";
import fall from "../resources/images/events/fall.svg";
import sell from "../resources/images/events/sell.svg";
import selection from "../resources/images/events/selection.svg";
import weightSVG from "../resources/images/events/weightSVG.svg";
import active_nipples from "../resources/images/events/active_nipples.svg";
import reclassify from "../resources/images/events/reclassify.svg";
import piglets_treatment from "../resources/images/events/piglets_treatment.svg";
import heat from "../resources/images/events/heat.svg";
import lost from "../resources/images/events/lost-rfid.svg";
import castration from "../resources/images/events/castration.svg";
import tattoo from "../resources/images/events/tattoo.svg";
import comments from "../resources/images/events/comments.svg";
import tagging from "../resources/images/events/pig-number.svg";
import sow from "../resources/images/animal-kind-chooser/sow.svg";
import {checkIfUserIsService} from "./NewRolesUtils";

function getProperAnimalPrivilegesForPigletsOrPorkers(animalKind) {
    const privileges = {
        packageKeys: [LicPackageKeys.PORKER],
        packageLevels: [LicPackageLevel.BASIC],
        eligibleAnimal: [AnimalTypes.PORKER],
    };
    if (animalKind === AnimalTypes.PIGLET) {
        privileges.packageKeys = [LicPackageKeys.SOW];
        privileges.eligibleAnimal = [AnimalTypes.PIGLET];
    }
    if (animalKind === "ALL") {
        privileges.packageKeys = [LicPackageKeys.SOW, LicPackageKeys.PORKER];
        privileges.eligibleAnimal = [AnimalTypes.PIGLET, AnimalTypes.PORKER];
    }
    return privileges;
}

export function getEventsList(t, FarmID, animalKind) {
    return [
        {
            label: t("insertion"),
            value: "animalKind/insertion",
            svgPath: insertion,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.PIGLET,
                AnimalTypes.PORKER,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.INSERTION + "_" + animalKind,
                    eventChooserFormNames.INSERTION + "_" + -animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("insemination"),
            value: "insemination",
            svgPath: insemination,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.RENOVATION_SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.INSEMINATION + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("usg"),
            value: "usg",
            svgPath: usg,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts([eventChooserFormNames.USG], FarmID),
        },
        {
            label: t("noPregnancy"),
            value: "noPregnancy",
            svgPath: noPregnancy,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.NO_PREGNANCY],
                FarmID
            ),
        },
        {
            label: t("parturition"),
            value: "parturition",
            svgPath: parturition,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.PARTURITION],
                FarmID
            ),
        },
        {
            label: t("apiNotifications.deliverySettlementTitle"),
            value: "parturitionState",
            svgPath: parturition,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.PARTURITION_STATE],
                FarmID
            ),
        },
        {
            label: t("separationToPigletHouse"),
            value: "separationToPigletHouse",
            svgPath: separationPorkhouse,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_PORKHOUSE],
                FarmID
            ),
        },
        {
            label: t("giltsSeparation"),
            value: "giltsSeparation",
            svgPath: separationPorkhouse,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.GILTS_SEPARATION],
                FarmID
            ),
        },
        {
            label: t("separationToMommy"),
            value: "separationToMommy",
            svgPath: separationMommy,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_MOMMY],
                FarmID
            ),
        },
        {
            label: t("separationGiltsToMommy"),
            value: "separationGiltsToMommy",
            svgPath: separationMommy,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_MOMMY_GILTS],
                FarmID
            ),
        },
        {
            label: t("reportTreatment"),
            value: "grafting",
            svgPath: grafting,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.GRAFTING + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("reportTreatment"),
            value: `type?next=grafting${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: grafting,
            ...getProperAnimalPrivilegesForPigletsOrPorkers(animalKind),
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.GRAFTING + "_" + animalKind,
                    eventChooserFormNames.GRAFTING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("scheduleOfTreatment"),
            value: "scheduleOfTreatment",
            svgPath: treatment,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.TREATMENT + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("scheduleOfTreatment"),
            value: `type?next=scheduleOfTreatment${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: treatment,
            ...getProperAnimalPrivilegesForPigletsOrPorkers(animalKind),
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.TREATMENT + "_" + animalKind,
                    eventChooserFormNames.TREATMENT_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("fallPiglets"),
            value: "fallPiglets",
            svgPath: fallPiglets,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FALL_PIGLETS],
                FarmID
            ),
        },
        {
            label: t("fallTattooedPiglets"),
            value: "fallTattooedPiglets",
            svgPath: fallPiglets,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FALL_TATTOOED_PIGLETS],
                FarmID
            ),
        },
        {
            label: t("transfer"),
            value: "locationChooser/transfer",
            svgPath: transfer,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.BOAR],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.TRANSFER_STAND + "_" + animalKind,
                    eventChooserFormNames.TRANSFER_CHAMBER + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("transfer"),
            value: "type?next=locationChooser/transfer",
            svgPath: transfer,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.PIGLET,
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.PORKER,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.TRANSFER_STAND + "_" + animalKind,
                    eventChooserFormNames.TRANSFER_CHAMBER + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("fall"),
            value: "fall",
            svgPath: fall,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FALL + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("fall"),
            value: `type?next=fall${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: fall,
            ...getProperAnimalPrivilegesForPigletsOrPorkers(animalKind),
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.FALL + "_" + animalKind,
                    eventChooserFormNames.FALL_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("sale"),
            value: "sale",
            svgPath: sell,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.SELL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SELL + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("sale"),
            value: "type?next=sale",
            svgPath: sell,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.SELL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.SELL + "_" + animalKind,
                    eventChooserFormNames.SELL_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("selection"),
            value: "selection",
            svgPath: selection,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.SELL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SELECTION + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("weighting"),
            value: "weighting",
            svgPath: weightSVG,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.WEIGHTING + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("weighting"),
            value: `type?next=weighting${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: weightSVG,
            ...getProperAnimalPrivilegesForPigletsOrPorkers(animalKind),
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.WEIGHTING + "_" + animalKind,
                    eventChooserFormNames.WEIGHTING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("activeNipples"),
            value: "activeNipples",
            svgPath: active_nipples,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.ACTIVE_NIPPLES],
                FarmID
            ),
        },
        {
            label: t("reclassify"),
            value: "type?next=reclassify",
            svgPath: reclassify,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.RECLASSIFY + "_" + animalKind,
                    eventChooserFormNames.RECLASSIFY_LOCATION +
                        "_" +
                        animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("reclassify"),
            value: "reclassifySow",
            svgPath: reclassify,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.RENOVATION_SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.RECLASSIFY_SOW + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("pigletsMedication"),
            value: "pigletsMedication",
            svgPath: piglets_treatment,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PIGLETS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.PIGLETS_TREATMENT],
                FarmID
            ),
        },
        {
            label: t("heat"),
            value: "heat",
            svgPath: heat,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.RENOVATION_SOW, AnimalTypes.SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.HEAT + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("lostEarring"),
            value: "lostEarring",
            svgPath: lost,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.PIGLET,
                AnimalTypes.BOAR,
                AnimalTypes.PORKER,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.LOST_EARRING + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("dosatron"),
            value: "dosatron/chooser",
            svgPath: grafting,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC, LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.PIGLET,
                AnimalTypes.BOAR,
                AnimalTypes.PORKER,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.DOSATRON + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("pigletsTreatment"),
            value: "pigletsTreatment",
            svgPath: castration,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PIGLETS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.CASTRATION],
                FarmID
            ),
        },
        {
            label: t("tattooing"),
            value: "tattoo",
            svgPath: tattoo,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.TATTOO + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("fatMeasurement"),
            value: "fatMeasurement",
            svgPath: sow,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FAT_MEASUREMENT],
                FarmID
            ),
        },
        {
            label: t("printSelectedAnimalsModal.comments"),
            value: "comments",
            svgPath: comments,
            packageKeys: [LicPackageKeys.SOW, LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.PIGLET,
                AnimalTypes.PORKER,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.COMMENTS + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("tagging"),
            value: "type?next=tagging",
            svgPath: tagging,
            packageKeys: [LicPackageKeys.PORKER],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.TAGGING + "_" + animalKind,
                    eventChooserFormNames.TAGGING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("eventTypes.W"),
            value: "locationChooser/isMommy",
            svgPath: tagging,
            packageKeys: [LicPackageKeys.SOW],
            packageLevels: [LicPackageLevel.BASIC],
            eligibleAnimal: [AnimalTypes.RENOVATION_SOW, AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.IS_MOMMY],
                FarmID
            ),
            show: checkIfUserIsService(),
        },
    ];
}
